import createIcon from '../../createIcon';

/**
 * @component @name FormatClear
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC4yNyA0TDMgNS4yN0w5Ljk3IDEyLjI0TDcuNSAxOEgxMC41TDEyLjA3IDE0LjM0TDE3LjczIDIwTDE5IDE4LjczTDQuNTUgNC4yN0w0LjI3IDRaTTcgNFY0LjE4TDkuODIgN0gxMi4yMkwxMS41IDguNjhMMTMuNiAxMC43OEwxNS4yMSA3SDIxVjRIN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatClear = createIcon('FormatClear', [
  [
    'path',
    {
      d: 'M4.27 4L3 5.27L9.97 12.24L7.5 18H10.5L12.07 14.34L17.73 20L19 18.73L4.55 4.27L4.27 4ZM7 4V4.18L9.82 7H12.22L11.5 8.68L13.6 10.78L15.21 7H21V4H7Z',
      key: '2ksipe',
    },
  ],
]);

export default FormatClear;
